export default class MobileFilter {

	constructor(filter, config = {}) {
		if (!filter || !filter instanceof HTMLElement) {
			console.error('1st parameter is required but not given or not of type HTML-Element');
		} else {
			let defaultConfig = {
				mobileBreakpoint: 767,
				autoToggle: true,
				selectorCategory: '.js-dc-mobileFilter-category',
				selectorCategoryToggle: '.js-dc-mobileFilter-category-toggle',
				selectorFilterToggle: '.js-dc-mobileFilter-filter-toggle',
				selectorFilterToggleLabel: '.js-dc-mobileFilter-filter-toggle-label',
				cssClassCategoryToggle: 'open',
				cssClassFilterToggle: 'open',
				cssClassBodyScroll: 'dc-mobileFilter-open',
				attrFilterToggleLabelHide: 'data-label-hide',
				attrFilterToggleLabelShow: 'data-label-show',
				showEvent: 'dc.mobileFilter.show',
				hideEvent: 'dc.mobileFilter.hide',
				showCategoryEvent: 'dc.mobileFilter.category.show',
				hideCategoryEvent: 'dc.mobileFilter.category.hide',
				subCategoryToggleEvent: 'dc.mobileFilter.subCategory.toggle'
			};

			this.config = Object.assign(defaultConfig, config);
			this.enabled;
			this.filter = filter;
			this.filterShown;
			this.eventListeners = false;
			this.filterToggleBtns = this.#findFilterToggleBtns();
			this.categories = this.#findCategories();
			this.#enable();

			if (this.config.autoToggle) {
				this.#autoToggle();
				window.addEventListener('resize', (e) => {
					this.#autoToggle();
				});
			}
		}
	}

	// Filter-Methods
	#autoToggle() {
		if (window.matchMedia(`(max-width: ${parseInt(this.config.mobileBreakpoint)}px)`).matches && !this.enabled) {
			this.#enable();
		}
		if (!window.matchMedia(`(max-width: ${parseInt(this.config.mobileBreakpoint)}px)`).matches && this.enabled) {
			this.#disable();
		}
	}

	#enable() {
		if (!this.eventListeners) {
			this.categories.forEach(cat => {
				cat.toggle.addEventListener('click', (e) => {
					if (this.enabled) {
						this.toggleCat(cat);
					}
				});
			});
			this.filterToggleBtns.forEach(btn => {
				btn.elem.addEventListener('click', (e) => {
					if (this.enabled) {
						this.#toggleFilter();
					}
				});
			});
			this.eventListeners = true;
		} else {
			this.categories.forEach(cat => {
				this.hideCat(cat);
			});
		}
		this.enabled = true;
	}

	#disable() {
		this.categories.forEach(cat => {
			this.showCat(cat);
		});
		this.enabled = false;
	}

	#findFilterToggleBtns() {
		let _this = this;
		let btnElems = Array.prototype.slice.call(this.filter.querySelectorAll(this.config.selectorFilterToggle));
		let results = [];
		btnElems.forEach(btn => {
			let btnLabel = btn.querySelector(this.config.selectorFilterToggleLabel);
			results.push({
				elem: btn,
				scrollTarget: document.querySelector(btn.getAttribute('data-scroll-target')),
				label: {
					elem: btnLabel,
					show: btn.getAttribute(_this.config.attrFilterToggleLabelShow),
					hide: btn.getAttribute(_this.config.attrFilterToggleLabelHide)
				}
			});
		});
		return results;
	}

	#toggleFilter() {
		if (this.filterShown) {
			this.hideFilter();
		} else {
			this.showFilter();
		}
	}

	hideFilter() {
		this.filter.classList.remove(this.config.cssClassFilterToggle);
		document.body.classList.remove(this.config.cssClassBodyScroll);

		let scrollTarget = undefined;
		this.filterToggleBtns.forEach(btn => {
			if (btn.label.elem && btn.label.show) {
				btn.label.elem.innerHTML = btn.label.show;
			}
			if (btn.scrollTarget) {
				scrollTarget = btn.scrollTarget;
			}
		});
		this.#triggerEvent(this.config.showEvent, this.filter);
		this.filterShown = false;

		if (scrollTarget) {
			scrollTarget.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}

	showFilter() {
		this.filter.classList.add(this.config.cssClassFilterToggle);
		document.body.classList.add(this.config.cssClassBodyScroll);
		this.filterToggleBtns.forEach(btn => {
			if (btn.label.elem && btn.label.hide) {
				btn.label.elem.innerHTML = btn.label.hide;
			}
		});
		this.#triggerEvent(this.config.hideEvent, this.filter);
		this.filterShown = true;
	}

	// Category-Methods
	#findCategories() {
		let _this = this;
		let cats = Array.prototype.slice.call(this.filter.querySelectorAll(this.config.selectorCategory));
		let result = [];
		cats.forEach(cat => {
			let toggle = cat.querySelector(this.config.selectorCategoryToggle);
			result.push({
				elem: cat,
				shown: cat.classList.contains(_this.config.cssClassCategoryToggle),
				toggle: toggle
			});
		});
		return result;
	}

	toggleCat(cat) {
		if (cat.shown) {
			this.hideCat(cat);
		} else {
			this.showCat(cat);
		}
	}

	hideCat(cat) {
		cat.elem.classList.remove(this.config.cssClassCategoryToggle);
		this.#triggerEvent(this.config.hideCategoryEvent, cat.elem);
		cat.shown = false;
	}

	showCat(cat) {
		cat.elem.classList.add(this.config.cssClassCategoryToggle);
		this.#triggerEvent(this.config.showCategoryEvent, cat.elem);
		cat.shown = true;
	}

	// Event-Handling
	#triggerEvent(name, target, additionalInfo = {}) {
		let event;
		if (name) {
			event = new CustomEvent(name, additionalInfo);
		}

		if (event && target && target instanceof EventTarget) {
			target.dispatchEvent(event);
		}
	}

}